import { render, staticRenderFns } from "./insuranceApplyFor.vue?vue&type=template&id=d31682b8&scoped=true&"
import script from "./insuranceApplyFor.vue?vue&type=script&lang=js&"
export * from "./insuranceApplyFor.vue?vue&type=script&lang=js&"
import style0 from "./insuranceApplyFor.vue?vue&type=style&index=0&id=d31682b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31682b8",
  null
  
)

export default component.exports